import { IBaseEventFact, ILabJobScopedFact } from './common';
import {
  LabJobAction,
  LabJobStatus,
} from '@principle-theorem/principle-core/interfaces';

export interface ILabJobEventFact
  extends ILabJobScopedFact,
    IBaseEventFact<LabJobAction, LabJobStatus> {}
